/**
 * 判斷錯誤是否值得重試。
 * 無 response = 網路錯誤或 timeout；5xx = 伺服器暫時性錯誤。
 * 4xx 不重試（權限 / 參數問題），且會觸發 api.service 的登出攔截器。
 */
const isRetryable = (e) => {
    const status = e?.response?.status
    return !status || (status >= 500 && status < 600)
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

/**
 * 以指數退避重試單一非同步操作。
 * 必須逐支 API 包裝，不可包在 Promise.all 外層。
 * @param {Function} fn 回傳 promise 的函式
 * @param {{retries?: number, baseDelay?: number}} options
 */
export async function withRetry(fn, { retries = 2, baseDelay = 300 } = {}) {
    for (let attempt = 0; ; attempt++) {
        try {
            return await fn()
        } catch (e) {
            if (attempt >= retries || !isRetryable(e)) throw e
            // jitter 避免多支 API 同時重試又打爆後端
            const delay = baseDelay * Math.pow(2, attempt) + Math.random() * 200
            console.warn(`[retry] 第 ${attempt + 1} 次失敗，${Math.round(delay)}ms 後重試`, e?.message)
            await sleep(delay)
        }
    }
}

export default { withRetry }
